<template>
  <div class="Others20Charts">
    <div class="o_20_item">
      <div class="o_20_item_value">{{ dataSet.source[0] ? dataSet.source[0].y || 0 : 0 }}</div>
      <div class="o_20_item_icon">
        <img src="../../../assets/img/Others20Charts/001.png" />
      </div>
      <div class="o_20_item_label">
        {{ dataSet.source[0] ? dataSet.source[0].x || '今日售票额统计' : '今日售票额统计' }}
      </div>
    </div>

    <div class="o_20_item">
      <div class="o_20_item_value">{{ dataSet.source[1] ? dataSet.source[1].y || 0 : 0 }}</div>
      <div class="o_20_item_icon">
        <img src="../../../assets/img/Others20Charts/002.png" />
      </div>
      <div class="o_20_item_label">
        {{ dataSet.source[1] ? dataSet.source[1].x || '今日售票额统计' : '今日售票额统计' }}
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/common/request';
export default {
  name: 'Others20Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  data() {
    return {
      debounce_subscribeConfigurationChange: null, // 订阅Configuration变化的防抖函数
      apiIntervalTaskID: null, // api任务的定时器ID
      staticIntervalTaskID: null, // 静态任务的定时器ID

      noData: false, // 是否没有数据

      dataSet: {
        seriesList: [],
        source: [],
      },
    };
  },
  computed: {
    xStyle() {
      return {
        fontSize: this.Configuration.propertyData.fontStyle.value.xAxisSize + 'px',
        color: this.Configuration.propertyData.fontStyle.value.xAxisColor,
      };
    },
  },
  created() {
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.startApiIntervalTask();
    this.startStaticIntervalTask();
  },
  methods: {
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearTimeout(this.apiIntervalTaskID);
      clearTimeout(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },

    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      clearTimeout(this.apiIntervalTaskID);

      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      console.log('startApiIntervalTask:>>>>', ChartsData?.apiData?.isUseInterval);

      if (ChartsData?.currenEntry !== 'apiData') return;

      this.getApiDataResByFilterAndResponseQuery()
        .then(this.setEchartsOptions)
        .catch(err =>
          console.log('startApiIntervalTask-getApiDataResByFilterAndResponseQuery failed:>>>>', err),
        )
        .finally(() => {
          if (ChartsData?.apiData?.isUseInterval) {
            console.log('开启 interval 任务，间隔请求');
            this.apiIntervalTaskID = setTimeout(
              () => this.startApiIntervalTask(),
              ChartsData?.apiData?.apiInterval * 1000,
            );
          }
        });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;

      if (ChartsData?.currenEntry !== 'staticData') return;

      if (chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let data = this.$_.cloneDeep(ChartsData.staticData);
        data.source.forEach(item => (item.y = 0));
        this.setEchartsOptions(data);
        setTimeout(() => this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData)), 0);

        this.staticIntervalTaskID = setTimeout(
          () => this.startStaticIntervalTask(),
          chartsAnimation?.staticRefreshIntervalTime * 1000,
        );
      } else {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');

        this.getApiDataRes()
          .then(res => {
            // query数据
            let keys = ChartsData.apiData.apiResponseQuery.split('.');
            if (keys.length) {
              console.log('keys:>>>>', keys);
              keys.forEach(key => (res = res[key]));
            }

            let result = null;

            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              result = this.run_script(ChartsData.apiData.apiFilter, res);
            } else {
              result = res;
            }

            resolve(result);
          })
          .catch(reject);
      });
    },
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');

        let param = {
          method: ChartsData.apiData.apiUrlMethod,
          url: ChartsData.apiData.apiUrl,
          params: {},
        };

        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          param['headers'] = { userkey: user_key };
        }

        request(param)
          .then(resolve)
          .catch(reject);
      });
    },

    setEchartsOptions(data = null) {
      console.log('setEchartsOptions:>>>>', data);

      if (!data) return (this.noData = true);
      this.dataSet = data;
    },

    /**
     * 运行脚本
     * @param {string} script 脚本
     * @param {*} data 数据
     */
    run_script(script, data) {
      let dataSet = {};
      try {
        eval(script);
      } catch (error) {
        console.error('run_script failed: ', error);
      }
      return dataSet;
    },
  },
  beforeUnmount() {
    clearTimeout(this.apiIntervalTaskID);
    clearTimeout(this.staticIntervalTaskID);
    this.unRegisterDebounceAndThrottle();
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  Configuration: {
    componentTitle: '单行分组组件',
    componentName: 'Others20Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others20Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['售票额'],
            source: [
              {
                s: '售票额',
                x: '今日售票额统计',
                y: 100,
              },
              {
                s: '售票额',
                x: '累计销售额统计',
                y: 10,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      textComponentUnits: {
        propertyComponentName: 'MapTextConfiger',
        value: '元',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.Others20Charts {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100%;
  .o_20_item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100px;
    .o_20_item_value {
      z-index: -1;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      font-size: 20px;
      font-weight: bold;
      color: transparent;
      text-wrap: nowrap;
      -webkit-background-clip: text;
    }
    .o_20_item_icon {
      display: flex;
      width: 93px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .o_20_item_label {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      text-wrap: nowrap;
      font-size: 14px;
      color: #fff;
    }
  }
  .o_20_item:nth-child(1) {
    .o_20_item_value {
      background-image: -webkit-linear-gradient(top, #ffffff, #4891ff);
    }
  }
  .o_20_item:nth-child(2) {
    .o_20_item_value {
      background-image: -webkit-linear-gradient(top, #ffffff, #26e77c);
    }
  }
}
</style>
